'use client';

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "component", "elevation", "square", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import clsx from 'clsx';
import integerPropType from '@mui/utils/integerPropType';
import chainPropTypes from '@mui/utils/chainPropTypes';
import composeClasses from '@mui/utils/composeClasses';
import { alpha } from '@mui/system/colorManipulator';
import { styled, useTheme } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import getOverlayAlpha from "../styles/getOverlayAlpha.js";
import { getPaperUtilityClass } from "./paperClasses.js";
import { jsx as _jsx } from "react/jsx-runtime";

var useUtilityClasses = function useUtilityClasses(ownerState) {
  var square = ownerState.square,
      elevation = ownerState.elevation,
      variant = ownerState.variant,
      classes = ownerState.classes;
  var slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && "elevation".concat(elevation)]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};

var PaperRoot = styled('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles["elevation".concat(ownerState.elevation)]];
  }
})(memoTheme(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow'),
    variants: [{
      props: function props(_ref2) {
        var ownerState = _ref2.ownerState;
        return !ownerState.square;
      },
      style: {
        borderRadius: theme.shape.borderRadius
      }
    }, {
      props: {
        variant: 'outlined'
      },
      style: {
        border: "1px solid ".concat((theme.vars || theme).palette.divider)
      }
    }, {
      props: {
        variant: 'elevation'
      },
      style: {
        boxShadow: 'var(--Paper-shadow)',
        backgroundImage: 'var(--Paper-overlay)'
      }
    }]
  };
}));
var Paper = /*#__PURE__*/React.forwardRef(function Paper(inProps, ref) {
  var _theme$vars$overlays;

  var props = useDefaultProps({
    props: inProps,
    name: 'MuiPaper'
  });
  var theme = useTheme();

  var className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'div' : _props$component,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = _objectWithoutProperties(props, _excluded);

  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    component: component,
    elevation: elevation,
    square: square,
    variant: variant
  });

  var classes = useUtilityClasses(ownerState);

  if (process.env.NODE_ENV !== 'production') {
    if (theme.shadows[elevation] === undefined) {
      console.error(["MUI: The elevation provided <Paper elevation={".concat(elevation, "}> is not available in the theme."), "Please make sure that `theme.shadows[".concat(elevation, "]` is defined.")].join('\n'));
    }
  }

  return /*#__PURE__*/_jsx(PaperRoot, _objectSpread(_objectSpread({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other), {}, {
    style: _objectSpread(_objectSpread({}, variant === 'elevation' && _objectSpread(_objectSpread({
      '--Paper-shadow': (theme.vars || theme).shadows[elevation]
    }, theme.vars && {
      '--Paper-overlay': (_theme$vars$overlays = theme.vars.overlays) === null || _theme$vars$overlays === void 0 ? void 0 : _theme$vars$overlays[elevation]
    }), !theme.vars && theme.palette.mode === 'dark' && {
      '--Paper-overlay': "linear-gradient(".concat(alpha('#fff', getOverlayAlpha(elevation)), ", ").concat(alpha('#fff', getOverlayAlpha(elevation)), ")")
    })), other.style)
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Paper;